<template>
	<div class="logout">
		Logout
	</div>
</template>

<script>
// @ is an alias to /src

export default {
	name: 'logout',
	mounted: function() {
		this.$store.dispatch('set_auth', null);
		this.$router.push('/');
	}
};
</script>
